export default {"src":"/education/_next/static/media/arrow-right-02.31ca0ca4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};